import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

export function AdminSocialPanel() {
  const [claims, setClaims] = useState([]);
  const [bonuses, setBonuses] = useState([]);
  const load = useCallback(() => {
    api.get("/admin/social/claims").then((r) => setClaims(r.data)).catch(() => {});
    api.get("/admin/social/referral-bonuses").then((r) => setBonuses(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  const run = async (fn, msg) => { try { await fn(); toast.success(msg); load(); } catch (e) { toast.error(formatApiError(e)); } };
  const waiting = bonuses.filter((b) => b.payout_status === "awaiting_approval");
  return (
    <section className="grid md:grid-cols-2 gap-4" data-testid="admin-social-panel">
      <div className="bg-white border border-[var(--line)] rounded-2xl p-5">
        <p className="font-serif text-xl mb-3">Page claims <span className="text-sm text-[var(--muted)]">({claims.length})</span></p>
        {!claims.length && <p className="text-sm text-[var(--muted)]">No claims waiting.</p>}
        {claims.map((c) => (
          <div key={c.claim_id} className="border-t border-[var(--line)] py-3 text-sm" data-testid={`admin-claim-${c.claim_id}`}>
            <p><Link to={`/v/${c.prospect_id}`} className="font-semibold hover:text-[var(--gold)]">{c.business_name}</Link> · {c.user_name} ({c.user_email})</p>
            {c.note && <p className="text-[var(--muted)] text-xs mt-1">{c.note}</p>}
            <div className="flex gap-2 mt-2"><button onClick={() => run(() => api.post(`/admin/social/claims/${c.claim_id}`, { approve: true }), "Claim approved")} className="btn-gold !py-1.5 !px-4 text-xs" data-testid={`admin-claim-approve-${c.claim_id}`}>Approve</button>
              <button onClick={() => run(() => api.post(`/admin/social/claims/${c.claim_id}`, { approve: false }), "Claim rejected")} className="btn-outline-gold !py-1.5 !px-4 text-xs" data-testid={`admin-claim-reject-${c.claim_id}`}>Reject</button></div>
          </div>))}
      </div>
      <div className="bg-white border border-[var(--line)] rounded-2xl p-5">
        <p className="font-serif text-xl mb-1">$5 host referral bonuses</p>
        <p className="text-xs text-[var(--muted)] mb-3">Vendors with us under a year need your approval; after a year they're paid automatically.</p>
        {!waiting.length && <p className="text-sm text-[var(--muted)]">Nothing waiting for approval. {bonuses.length} {bonuses.length === 1 ? "bonus" : "bonuses"} in total.</p>}
        {waiting.map((b) => (
          <div key={b.bonus_id} className="border-t border-[var(--line)] py-3 text-sm flex items-center gap-2" data-testid={`admin-bonus-${b.bonus_id}`}>
            <p className="flex-1">{b.vendor_name || "Vendor"} → {b.host_name || "host"} · ${b.amount}</p>
            <button onClick={() => run(() => api.post(`/admin/social/referral-bonuses/${b.bonus_id}/approve`), "Approved for payout")} className="btn-gold !py-1.5 !px-4 text-xs" data-testid={`admin-bonus-approve-${b.bonus_id}`}>Approve</button>
          </div>))}
      </div>
    </section>
  );
}
